// import React, { useEffect, useState } from "react";
// import axios from "../../../api/axiosInstance";
// import SectionCard from "./SectionCard";
// import { basicFields, religionFields, familyFields } from "./utils/fields";
// import toast from "react-hot-toast";
// import ProfileHeaderCard from "./ProfileHeaderCard";
// import { FaStar } from "react-icons/fa";
// const ProfileEditPage = () => {
//   const [profile, setProfile] = useState({});
//   const [loading, setLoading] = useState(true);

//   const fetchProfile = async () => {
//     try {
//       const res = await axios.get("/api/matrimony-profile/update/", {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });
//       setProfile(res.data);
//     } catch {
//       toast.error("Failed to load profile.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//   }, []);

//   // ProfileEditPage.jsx

//   const calculateProfileCompletion = (profile) => {
//     const totalFields = [
//       ...basicFields,
//       ...religionFields,
//       ...familyFields,
//       { name: "about_me" },
//       { name: "about_family" },
//       { name: "hobbies_and_interests" },
//     ];

//     const filledFields = totalFields.filter(
//       (field) =>
//         profile[field.name] && profile[field.name].toString().trim() !== ""
//     ).length;

//     return Math.round((filledFields / totalFields.length) * 100);
//   };

//   if (loading) return <div>Loading...</div>;

//   return (
//     <div className="w-full mx-auto p-4">
//       {!loading && (
//         <div className="w-full bg-gray-200 rounded-full h-5 mb-6 relative">
//           <div
//             className="bg-green-500 h-5 rounded-full transition-all duration-500"
//             style={{ width: `${calculateProfileCompletion(profile)}%` }}
//           ></div>
//           <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-gray-800">
//             Profile Completion: {calculateProfileCompletion(profile)}%
//           </span>
//         </div>
//       )}
//       {profile.profile_completed && (
//         <div className="mt-1 inline-flex items-center text-yellow-500 bg-yellow-100 rounded-full px-3 py-1 text-sm font-medium animate-pulse">
//           <FaStar className="mr-1" />
//           Profile Completion Star
//         </div>
//       )}

//       <ProfileHeaderCard profile={profile} />

//       <SectionCard
//         title="Basic Details"
//         data={profile}
//         fields={basicFields}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="Religion Information"
//         data={profile}
//         fields={religionFields}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="Family Details"
//         data={profile}
//         fields={familyFields}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="About you"
//         data={profile}
//         fields={[{ name: "about_me", label: "About Yourself" }]}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="About My Family"
//         data={profile}
//         fields={[{ name: "about_family", label: "About My Family" }]}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="Hobbies and Interests"
//         data={profile}
//         fields={[
//           { name: "hobbies_and_interests", label: "Hobbies and Interests" },
//         ]}
//         onUpdated={fetchProfile}
//       />
//     </div>
//   );
// };

// export default ProfileEditPage;

// import React, { useEffect, useState } from "react";
// import axios from "../../../api/axiosInstance";
// import SectionCard from "./SectionCard";
// import { basicFields, religionFields, familyFields } from "./utils/fields";
// import toast from "react-hot-toast";
// import ProfileHeaderCard from "./ProfileHeaderCard";
// import { FaStar } from "react-icons/fa";

// const ProfileEditPage = () => {
//   const [profile, setProfile] = useState({});
//   const [loading, setLoading] = useState(true);

//   const fetchProfile = async () => {
//     try {
//       const res = await axios.get("/api/matrimony-profile/update/", {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });
//       setProfile(res.data);
//     } catch {
//       toast.error("Failed to load profile.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//   }, []);

//   if (loading) return <div>Loading...</div>;

//   return (
//     <div className="w-full mx-auto p-4">
//       {/* Progress Bar */}
//       <div className="w-full bg-gray-200 rounded-full h-5 mb-6 relative overflow-hidden">
//         <div
//           className={`h-5 rounded-full transition-all duration-700 ease-in-out ${
//             profile.profile_completion_percentage < 50
//               ? "bg-red-500"
//               : profile.profile_completion_percentage < 80
//               ? "bg-yellow-400"
//               : "bg-green-500"
//           }`}
//           style={{ width: `${profile.profile_completion_percentage || 0}%` }}
//         ></div>
//         <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-gray-800">
//           Profile Completion: {profile.profile_completion_percentage || 0}%
//         </span>
//       </div>

//       {/* Star Badge */}
//       {profile.profile_completion_badge_awarded && (
//         <div className="mt-1 mb-1 inline-flex items-center text-yellow-500 bg-yellow-100 rounded-full px-3 py-1 text-sm font-medium animate-pulse shadow">
//           <FaStar className="mr-1" />
//           Profile Completion Star Earned!
//         </div>
//       )}

//       {/* Header Card */}
//       <ProfileHeaderCard profile={profile} />

//       {/* Editable Sections */}
//       <SectionCard
//         title="Basic Details"
//         data={profile}
//         fields={basicFields}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="Religion Information"
//         data={profile}
//         fields={religionFields}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="Family Details"
//         data={profile}
//         fields={familyFields}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="About you"
//         data={profile}
//         fields={[{ name: "about_me", label: "About Yourself" }]}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="About My Family"
//         data={profile}
//         fields={[{ name: "about_family", label: "About My Family" }]}
//         onUpdated={fetchProfile}
//       />
//       <SectionCard
//         title="Hobbies and Interests"
//         data={profile}
//         fields={[{ name: "hobbies_and_interests", label: "Hobbies and Interests" }]}
//         onUpdated={fetchProfile}
//       />
//     </div>
//   );
// };

// export default ProfileEditPage;

import React, { useEffect, useState } from "react";
import axios from "../../../api/axiosInstance";
import SectionCard from "./SectionCard";
import { basicFields, religionFields, familyFields, Maternal_Family_Details } from "./utils/fields";
import toast from "react-hot-toast";
import ProfileHeaderCard from "./ProfileHeaderCard";
import { FaStar, FaUpload } from "react-icons/fa";

const ProfileEditPage = () => {
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [videoFile, setVideoFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const fetchProfile = async () => {
    try {
      const res = await axios.get("/api/matrimony-profile/update/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setProfile(res.data);
    } catch {
      toast.error("Failed to load profile.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleVideoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (file.size > 50 * 1024 * 1024) {
        toast.error("Video exceeds 50MB limit.");
        return;
      }
      setVideoFile(file);
    }
  };

  const handleVideoUpload = async () => {
    if (!videoFile) {
      toast.error("Please select a video file first.");
      return;
    }
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("intro_video", videoFile);

      await axios.patch("/api/matrimony-profile/update/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      toast.success("Video uploaded successfully!");
      setVideoFile(null);
      fetchProfile();
    } catch (error) {
      console.error(error);
      toast.error("Failed to upload video. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="w-full mx-auto p-2">
      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-5 mb-6 relative overflow-hidden">
        <div
          className={`h-5 rounded-full transition-all duration-700 ease-in-out ${
            profile.profile_completion_percentage < 50
              ? "bg-red-500"
              : profile.profile_completion_percentage < 80
              ? "bg-yellow-400"
              : "bg-green-500"
          }`}
          style={{ width: `${profile.profile_completion_percentage || 0}%` }}
        ></div>
        <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-gray-800">
          Profile Completion: {profile.profile_completion_percentage || 0}%
        </span>
      </div>

      {/* Star Badge */}
      {profile.profile_completion_badge_awarded && (
        <div className="mt-1 mb-1 inline-flex items-center text-yellow-500 bg-yellow-100 rounded-full px-3 py-1 text-sm font-medium animate-pulse shadow">
          <FaStar className="mr-1" />
          Profile Completion Star Earned!
        </div>
      )}

      {/* Header Card */}
      <ProfileHeaderCard profile={profile} />

      {/* Editable Sections */}
      <SectionCard
        title="Basic Details"
        data={profile}
        fields={basicFields}
        onUpdated={fetchProfile}
      />
      <SectionCard
        title="Religion Information"
        data={profile}
        fields={religionFields}
        onUpdated={fetchProfile}
      />
      <SectionCard
        title="Family Details"
        data={profile}
        fields={familyFields}
        onUpdated={fetchProfile}
      />
      <SectionCard
        title="Maternal Family Details"
        data={profile}
        fields={Maternal_Family_Details}
        onUpdated={fetchProfile}
      />
      <SectionCard
        title="About you"
        data={profile}
        fields={[{ name: "about_me", label: "About Yourself" }]}
        onUpdated={fetchProfile}
      />
      <SectionCard
        title="About My Family"
        data={profile}
        fields={[{ name: "about_family", label: "About My Family" }]}
        onUpdated={fetchProfile}
      />
      <SectionCard
        title="Hobbies and Interests"
        data={profile}
        fields={[
          { name: "hobbies_and_interests", label: "Hobbies and Interests" },
        ]}
        onUpdated={fetchProfile}
      />

      {/* Video Upload Section */}
      <div className="mt-8 p-4 bg-white rounded-lg shadow border border-gray-200">
        <h2 className="text-lg font-semibold mb-2 flex items-center">
          <FaUpload className="mr-2 text-pink-600" />
          Upload Introduction Video
        </h2>
        <p className="text-sm text-gray-600 mb-3">
          Upload a short self-introduction video to enhance your profile.
          <br />
          <span className="text-red-500 font-semibold">
            Max size: 50MB
          </span>{" "}
          (MP4 recommended)
        </p>
        <div className="flex flex-col md:flex-row items-center gap-4">
          <input
            type="file"
            accept="video/*"
            onChange={handleVideoChange}
            className="border px-3 py-2 rounded w-full md:w-auto"
            onUpdated={fetchProfile}
          />
          <button
            onClick={handleVideoUpload}
            disabled={!videoFile || uploading}
            className={`px-4 py-2 rounded font-semibold transition ${
              !videoFile || uploading
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-pink-600 hover:bg-pink-700 text-white"
            }`}
          >
            {uploading ? "Uploading..." : "Upload Video"}
          </button>
        </div>

        {profile.intro_video && (
          <video
            controls
            src={profile.intro_video}
            className="mt-4 rounded w-full max-w-md"
          >
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  );
};

export default ProfileEditPage;
